/* global _ */
const sceneQuestions = [
  {
    page: 'homeFurnishing',
    statusKey: 'house',
  },
  {
    page: 'communications',
    statusKey: 'communications',
  },
  {
    page: 'eatingIn',
    statusKey: 'food',
  },
  {
    page: 'eatingOut',
    statusKey: 'eatout',
  },
  {
    page: 'transport',
    statusKey: 'transport',
  },
  {
    page: 'holidays',
    statusKey: 'holiday',
  },
  {
    page: 'leisure',
    statusKey: 'leisure',
  },
  {
    page: 'personal',
    statusKey: 'personal',
  },
  {
    page: 'health',
    statusKey: 'health',
  },
];

const sceneQuestionPages = _.map(sceneQuestions, (q) => q.page);

const allPages = [
  'welcome',
  'cohabiting',
  // 'location',
  ...sceneQuestionPages,
  'loading',
  'results',
  'disclaimer-and-assumptions',
];

export default {
  state: {
    sceneQuestions,
    currentPageIndex: 0,
    lastVisitedPageIndex: null,
    showForeground: true,
    hasSceneAnimations: true,
    isAnimating: false,
  },
  getters: {
    currentPage: state => allPages[state.currentPageIndex],
    isOnPage: (state, getters) => pageName => getters.currentPage === pageName,
    isOnQuestionPage: (state, getters) => _.includes(['cohabiting', ...sceneQuestionPages], getters.currentPage),
  },
  mutations: {
    goToNextPage(state) {
      state.lastVisitedPageIndex = state.currentPageIndex;
      state.currentPageIndex++;
    },
    goToPreviousPage(state) {
      state.lastVisitedPageIndex = state.currentPageIndex;
      state.currentPageIndex--;
    },
    goToPage(state, pageName) {
      state.lastVisitedPageIndex = state.currentPageIndex;
      state.currentPageIndex = allPages.indexOf(pageName);
    },
    goToLastVisitedPage(state) {
      const tempLastVisitedPageIndex = state.lastVisitedPageIndex;
      state.lastVisitedPageIndex = state.currentPageIndex;
      state.currentPageIndex = tempLastVisitedPageIndex;
    },
    setIsAnimating(state, status) {
      state.isAnimating = status;
    },
    setIsEditingAssumptions(state, value) {
      state.isEditingAssumptions = value;
    },
  },
}
